import { render, staticRenderFns } from "./Company-Detail.vue?vue&type=template&id=c39846fa&scoped=true"
import script from "./Company-Detail.vue?vue&type=script&lang=js"
export * from "./Company-Detail.vue?vue&type=script&lang=js"
import style0 from "./Company-Detail.vue?vue&type=style&index=0&id=c39846fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39846fa",
  null
  
)

export default component.exports